import script from "./OldVersion.vue?vue&type=script&setup=true&lang=ts"
export * from "./OldVersion.vue?vue&type=script&setup=true&lang=ts"

import "./OldVersion.vue?vue&type=style&index=0&id=3b3c8001&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3c8001"]])

export default __exports__